import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  uid = '';
  mapurl = '';

  constructor() { }

  setuid(uid): void{
    this.uid = uid;
  }

  getuid(){
    return this.uid;
  }

  setmapurl(mapurl): void{
    this.mapurl = mapurl;
  }

  getmapurl(){
    return this.mapurl;
  }

}
